<template>
  <div :class="classes">
    <UIcon
      :name="icons[item.labelIcon]"
      class="w-5 h-5 text-gray-900 flex-none"
      aria-hidden="true"
    />
    <TText
      variant="semibold"
      :size="smallText ? 'sm' : 'base'"
      classes="m-0 flex-initial"
      >{{ item.title }}</TText
    >
    <TText :size="smallText ? 'sm' : 'base'" classes="m-0 flex-initial">{{
      item.value
    }}</TText>
  </div>
</template>

<script setup lang="ts">
import type { OnlineBookingRowIcon } from '~~/modules/online-booking/entities/OnlineBookingRowIcon'

const icons: Record<OnlineBookingRowIcon['labelIcon'], string> = {
  clock: 'i-heroicons-outline-clock',
  'circle-stack': 'i-heroicons-outline-circle-stack',
  'credit-card': 'i-heroicons-outline-credit-card',
}

interface propsInterface {
  item: OnlineBookingRowIcon
  smallText?: boolean
  classes?: string
}

withDefaults(defineProps<propsInterface>(), {
  smallText: false,
  classes: 'flex gap-x-1 mb-4',
})
</script>
